import React, { useState, useEffect, useRef } from 'react';
import { XCircle, Eye, EyeOff } from 'lucide-react';

const PinModal = ({ onSuccess, onClose, mode = 'create' }) => {
    const [pin, setPin] = useState('');
    const [confirmPin, setConfirmPin] = useState('');
    const [error, setError] = useState('');
    const [isFirstTime, setIsFirstTime] = useState(false);
    const [showPin, setShowPin] = useState(false);
    const inputRef = useRef(null);  // Referência para o input
    
    useEffect(() => {
        // Auto-focus no input quando o modal abrir
        inputRef.current?.focus();
        const savedPin = localStorage.getItem('settings_pin');
        setIsFirstTime(!savedPin);
    }, []);

    // Função para lidar com o Enter
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

   const handlePinChange = (e) => {
       const value = e.target.value.replace(/\D/g, '');
       if (value.length <= 4) {
           setPin(value);
           setError('');
       }
   };

   const handleConfirmPinChange = (e) => {
       const value = e.target.value.replace(/\D/g, '');
       if (value.length <= 4) {
           setConfirmPin(value);
           setError('');
       }
   };

   const handleSubmit = () => {
       if (mode === 'validate') {
           // Modo de validação para visualizar valores
           const savedPin = localStorage.getItem('settings_pin');
           if (pin === savedPin) {
               onSuccess();
           } else {
               setError('PIN incorreto');
           }
           return;
       }

       // Modo de criação/configuração do PIN
       if (isFirstTime) {
           if (pin.length !== 4) {
               setError('PIN deve ter 4 dígitos');
               return;
           }
           if (pin !== confirmPin) {
               setError('PINs não coincidem');
               return;
           }
           localStorage.setItem('settings_pin', pin);
           localStorage.setItem('pin_protection', 'true');
           onSuccess();
       } else {
           const savedPin = localStorage.getItem('settings_pin');
           if (pin === savedPin) {
               localStorage.setItem('pin_protection', 'true');
               onSuccess();
           } else {
               setError('PIN incorreto');
           }
       }
   };

   return (
       <div style={{
           position: 'fixed',
           top: 0,
           left: 0,
           right: 0,
           bottom: 0,
           backgroundColor: 'rgba(0, 0, 0, 0.5)',
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           zIndex: 1000
       }}>
           <div style={{
               backgroundColor: 'white',
               padding: '20px',
               borderRadius: '8px',
               width: '300px',
               position: 'relative'  // Para posicionar o botão X
            }}>
                {/* Botão X para fechar */}
                <button 
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '10px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '5px'
                    }}
                >
                    <XCircle size={20} />
                </button>

               <h2 style={{ 
                   color: '#2D3277', 
                   marginBottom: '20px',
                   textAlign: 'center' ,
                   paddingRight: '20px'  // Espaço para o X

               }}>
                   {mode === 'validate' ? 'Digite seu PIN' : 
                    isFirstTime ? 'Criar PIN' : 'Digite seu PIN'}
               </h2>

               <div style={{ marginBottom: '15px' }}>
                   <div style={{ position: 'relative' }}>
                       <input
                            ref={inputRef}  // Referência para auto-focus
                           type={showPin ? 'text' : 'password'}
                           value={pin}
                           onChange={handlePinChange}
                           onKeyPress={handleKeyPress}  // Handler para o Enter
                           placeholder="Digite o PIN"
                           style={{
                               width: '85%',
                               padding: '8px 35px 8px 12px',
                               borderRadius: '4px',
                               border: '1px solid #ddd'
                           }}
                       />
                       <button
                           onClick={() => setShowPin(!showPin)}
                           style={{
                               position: 'absolute',
                               right: '8px',
                               top: '50%',
                               transform: 'translateY(-50%)',
                               background: 'none',
                               border: 'none',
                               cursor: 'pointer'
                           }}
                       >
                           {showPin ? <EyeOff size={18} /> : <Eye size={18} />}
                       </button>
                   </div>
               </div>

               {isFirstTime && mode !== 'validate' && (
                   <div style={{ marginBottom: '15px' }}>
                       <input
                           type={showPin ? 'text' : 'password'}
                           value={confirmPin}
                           onChange={handleConfirmPinChange}
                           placeholder="Confirme o PIN"
                           style={{
                               width: '85%',
                               padding: '8px 12px',
                               borderRadius: '4px',
                               border: '1px solid #ddd'
                           }}
                       />
                   </div>
               )}

               {error && (
                   <div style={{
                       color: '#dc3545',
                       fontSize: '0.9rem',
                       marginBottom: '15px',
                       textAlign: 'center'
                   }}>
                       {error}
                   </div>
               )}

               <button
                   onClick={handleSubmit}
                   style={{
                       width: '100%',
                       padding: '10px',
                       backgroundColor: '#2D3277',
                       color: 'white',
                       border: 'none',
                       borderRadius: '4px',
                       cursor: 'pointer'
                   }}
               >
                   {mode === 'validate' ? 'Validar' :
                    isFirstTime ? 'Criar PIN' : 'Entrar'}
               </button>
           </div>
       </div>
   );
};

export default PinModal;
